import style from './02_pricingstudents.css'

import ico1 from '../../Images/money-bag.png'
import ico2 from '../../Images/money.png'
import ico3 from '../../Images/hundred-points.png'
import ico4 from '../../Images/coaching.png'

export default function PricingStudents() {
    return (
        <div style={{ backgroundColor: '#FFFDF4' }}>
            <div className='pricingstudentspage-main'>
                <h2>You Learn. They Earn.</h2>
                <p>SurSaathi connects students with great music teachers. Your teacher remains in complete control of their lessons, pricing, and schedule. Every lesson you book directly supports your teacher. When you contact a teacher through SurSaathi:</p>
                <div className='pricingstudentspage-main-flex'>
                    <div className='pricingstudentspage-main-flex-card'>
                        <img src={ico1} alt="" />
                        <h3>Teachers Set Their Own Fees</h3>
                        <span>Every teacher chooses their own lesson rates.</span>
                    </div>
                    <div className='pricingstudentspage-main-flex-card'>
                        <img src={ico2} alt="" />
                        <h3>Pay Your Teacher Directly</h3>
                        <span>Payments are made directly between you and your teacher.</span>
                    </div>
                    <div className='pricingstudentspage-main-flex-card'>
                        <img src={ico3} alt="" />
                        <h3>100% Goes to the Teacher</h3>
                        <span>SurSaathi doesn't take commissions from lesson fees.</span>
                    </div>
                    <div className='pricingstudentspage-main-flex-card'>
                        <img src={ico4} alt="" />
                        <h3>Flexible Learning</h3>
                        <span>Book online or in-person lessons based on availability.</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
